import HttpService from '@/api/HttpService';

const ROUTE_RECORD_MAP = {
  UserDetail: { type: 'user', param: 'userId' },
  EditFinancialAdvisor: { type: 'user', param: 'userId' },
  AccountDetail: { type: 'account', param: 'accountId' },
  EditIndividualAccount: { type: 'account', param: 'accountId' },
  EditInstitutionAccount: { type: 'account', param: 'accountId' },
  EditTrustAccount: { type: 'account', param: 'accountId' },
  EditJointAccount: { type: 'account', param: 'accountId' },
  NoteDetail: { type: 'note', param: 'noteId' },
};

export default function trackRecentRecord(to) {
  const mapping = ROUTE_RECORD_MAP[to.name];
  if (!mapping) return;

  const recordId = parseInt(to.params[mapping.param], 10);
  if (!Number.isInteger(recordId) || recordId <= 0) return;

  HttpService.postV2('recent-records', {
    recordType: mapping.type,
    recordId,
  }).catch(() => {});
}



// WEBPACK FOOTER //
// ./src/router/recentRecordsTracker.js